import { render, staticRenderFns } from "./goods_detail.vue?vue&type=template&id=a457f0c4&scoped=true"
import script from "./goods_detail.vue?vue&type=script&lang=js"
export * from "./goods_detail.vue?vue&type=script&lang=js"
import style0 from "./goods_detail.vue?vue&type=style&index=0&id=a457f0c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a457f0c4",
  null
  
)

export default component.exports